<form [hidden]="hidden" #paymentForm="ngForm">
  <div id="submit-payment-container" class="grid grid-cols-1">
    <div class="self-tour-step-header">
      <div class="text-xl font-denim-semibold">ENTER PAYMENT INFORMATION</div>
      <div *ngIf="tourCost" class="text-gray-tricon mt-4">To verify your identity, a ${{tourCost}} fee will be charged to prevent identity theft or damages.</div>
    </div>

    <div class="grid grid-cols-1">
      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Name (as it appears on your card)</mat-label>
        <input matInput type="text" name="cust-name" id="customer-name" required [(ngModel)]="customerName">
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <div class="my-2 pb-5">
        <label>Payment Card Number</label>
          <div id="ccNumberAnchor" class="stripe-tour-field"></div>
      </div>
      <div id="checkout-middle-cont" class="my-2 pb-5">
        <div>
          <label>Expiration Date</label>
          <div id="ccExpireAnchor" class="stripe-tour-field"></div>
        </div>
        <div>
          <label>CVC</label>
          <div id="ccCVCAnchor" class="stripe-tour-field"></div>
        </div>
      </div>

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Billing Address</mat-label>
        <input matInput type="text" name="Address" id="billing-address" required [(ngModel)]="address">
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
        <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
          <mat-label>City</mat-label>
          <input matInput type="text" name="City" id="cc-city" required [(ngModel)]="city">
          <mat-error>
            Please fill out this field
          </mat-error>
        </mat-form-field>

        <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
          <mat-label>Billing Zip Code</mat-label>
          <input matInput type="text" name="Zip" id="tour-biling-zip" required [(ngModel)]="billingZipCode">
          <mat-error>
            Please fill out this field
          </mat-error>
        </mat-form-field>
      </div>

      <mat-form-field class="my-2" hideRequiredMarker="true">
        <mat-label>Country</mat-label>
        <mat-select name="Country" id="Country" required [(ngModel)]="billingCountry" #Country="ngModel">
          <mat-option *ngFor="let count of country" [value]="count.value">
            {{count.label}}
          </mat-option>
        </mat-select>
        <mat-error>Please fill out this field</mat-error>
      </mat-form-field>
    </div>

    <div class="flex justify-end">
      <div class="w-full sm:w-1/2">
        <div class="grid grid-cols-2 col-gap-4">
          <button mat-flat-button color="accent" (click)="back()">BACK</button>
          <button mat-flat-button color="accent" (click)="submitPayment($event.target)" [disabled]="!paymentForm.form.valid">SUBMIT PAYMENT</button>
      </div>
    </div>
  </div>
  </div>
</form>
